// extracted by mini-css-extract-plugin
export var active = "_lh-e";
export var blink = "_lh-f";
export var dropDownSelector = "_lh-5";
export var dropDownWrapper = "_lh-4";
export var fakeCursor = "_lh-d";
export var fontSizeButton = "_lh-7";
export var formQuillEditor = "_lh-0";
export var pressed = "_lh-g";
export var qlBlank = "_lh-1";
export var textFormattingToolbar = "_lh-2";
export var textFormattingToolbarClosed = "_lh-3";
export var textFormattingToolbarInline = "_lh-6";
export var textToolbarOption = "_lh-8";
export var toolbarCell = "_lh-a";
export var toolbarCellCollapsed = "_lh-b";
export var toolbarOptionHitArea = "_lh-c";
export var toolbarOverflow = "_lh-9";